import { routeDomain, type AgentDomain } from '../../aiAssistant/routeDomain'

export function resolveTurnCompletionDomain(options: {
    metadata: Record<string, unknown>
    conversationDomain: AgentDomain | null
    pathname: string
    hasPendingChartCommands: boolean
    chartCommandsAlreadyApplied: boolean
}): AgentDomain | null {
    if (options.hasPendingChartCommands || options.chartCommandsAlreadyApplied) {
        return 'chart'
    }

    const metaDomain = String(
        options.metadata.conversation_domain ?? options.metadata.agent ?? '',
    ).toLowerCase()
    if (metaDomain === 'chart' || metaDomain === 'screener' || metaDomain === 'trading') {
        return metaDomain as AgentDomain
    }

    return options.conversationDomain ?? routeDomain(options.pathname)
}

export function isTerminalChatEvent(eventType: string, status: string): boolean {
    if (eventType === 'RUN_FINISHED' || eventType === 'RUN_ERROR' || eventType === 'RUN_CANCELLED') {
        return true
    }
    const normalizedStatus = status.toLowerCase()
    return normalizedStatus === 'completed' || normalizedStatus === 'failed' || normalizedStatus === 'cancelled'
}
